import FormattedMessage from 'I18n/components/FormattedMessage';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { WarningIcon } from 'foundations-assets/icons/components/WarningIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const SensitiveScopeGroupWarningIcon = ({
  highlySensitive = false,
  paddingInline,
  paddingInlineStart,
  paddingInlineEnd
}) => {
  const color = highlySensitive ? 'fill-alert-pressed' : 'fill-accent-yellow-default';
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: highlySensitive ? 'developer-experience-shared-components.scopes.highlySensitiveTooltip' : 'developer-experience-shared-components.scopes.sensitiveTooltip'
    }),
    children: /*#__PURE__*/_jsx(IconHolder, {
      verticalAlign: "middle",
      size: "300",
      icon: WarningIcon,
      color: color,
      paddingBlockStart: "0",
      paddingBlockEnd: "25",
      paddingInline: paddingInline || '0',
      paddingInlineStart: paddingInlineStart,
      paddingInlineEnd: paddingInlineEnd
    })
  });
};
export default SensitiveScopeGroupWarningIcon;